'use client';

import { c as _c } from "react/compiler-runtime";
import { useLocale } from 'next-intl';
import { useState } from 'react';
import { ButtonVariant } from '@shared/ui-components/button/buttonVariant';
import { ModalTrigger } from '@shared/ui-components/modal/modal';
import { LockIconZoomedIn } from '@shared/ui-components/svgs';
import { Button } from '../../../../../../components/button/button';
import { Dialog } from '../../../../../../components/dialog/dialog';
import { useUserContext } from '../../../../../../components/providers/user-context';
import { HOMEPAGE_PATH } from '../../../../../../utils/constants/local-paths';
import { loginHandler } from '../../../../../../utils/helpers/login-handler';
import styles from './locked-resource-prompt.module.scss';
type UseLockedResourcePromptProps = {
  cmsContent: {
    cancelLabel: string;
    lockedResourceModalApplyLabel: string;
    lockedResourceModalApplyPagePath: string;
    lockedResourceModalHeading: string;
    lockedResourceModalNonMemberSubheading: string;
    lockedResourceModalSubheading: string;
    loginLinkLabel: string;
  };
  isResourceLocked: boolean;
  resourceUrl: null | string | undefined;
};
export const useLockedResourcePrompt = t0 => {
  const $ = _c(24);
  const {
    cmsContent,
    isResourceLocked,
    resourceUrl
  } = t0;
  const locale = useLocale();
  const [isLockedResourcePromptVisible, setIsLockedResourcePromptVisible] = useState(false);
  const {
    isAuthenticated
  } = useUserContext();
  const shouldLockedResourcePromptBeShown = isResourceLocked;
  const shouldPromptToApplyForMembership = isAuthenticated;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setIsLockedResourcePromptVisible(false);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const closeLockedResourcePrompt = t1;
  let t2;
  if ($[1] !== shouldLockedResourcePromptBeShown) {
    t2 = () => {
      if (shouldLockedResourcePromptBeShown) {
        setIsLockedResourcePromptVisible(true);
      }
    };
    $[1] = shouldLockedResourcePromptBeShown;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const onResourceClick = t2;
  let t3;
  if ($[3] !== locale || $[4] !== resourceUrl) {
    t3 = () => {
      loginHandler({
        authorizationParameters: {
          ui_locales: locale
        },
        options: {
          redirectTo: resourceUrl || HOMEPAGE_PATH
        }
      });
    };
    $[3] = locale;
    $[4] = resourceUrl;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const onSignInClick = t3;
  const subheading = shouldPromptToApplyForMembership ? cmsContent.lockedResourceModalNonMemberSubheading : cmsContent.lockedResourceModalSubheading;
  let t4;
  if ($[6] !== cmsContent.cancelLabel) {
    t4 = <Button onClick={closeLockedResourcePrompt} variant={ButtonVariant.Secondary}>{cmsContent.cancelLabel}</Button>;
    $[6] = cmsContent.cancelLabel;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const cancelButton = t4;
  let t5;
  if ($[8] !== cmsContent.lockedResourceModalApplyLabel || $[9] !== cmsContent.lockedResourceModalApplyPagePath || $[10] !== cmsContent.loginLinkLabel || $[11] !== onSignInClick || $[12] !== shouldPromptToApplyForMembership) {
    t5 = shouldPromptToApplyForMembership ? <Button to={cmsContent.lockedResourceModalApplyPagePath}>{cmsContent.lockedResourceModalApplyLabel}</Button> : <Button onClick={onSignInClick}>{cmsContent.loginLinkLabel}</Button>;
    $[8] = cmsContent.lockedResourceModalApplyLabel;
    $[9] = cmsContent.lockedResourceModalApplyPagePath;
    $[10] = cmsContent.loginLinkLabel;
    $[11] = onSignInClick;
    $[12] = shouldPromptToApplyForMembership;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  const primaryButton = t5;
  let t6;
  if ($[14] !== cancelButton || $[15] !== cmsContent.lockedResourceModalHeading || $[16] !== isLockedResourcePromptVisible || $[17] !== primaryButton || $[18] !== subheading) {
    t6 = () => <ModalTrigger isOpen={isLockedResourcePromptVisible}>{() => <Dialog onModalClose={closeLockedResourcePrompt}><div className={styles["locked-resource-prompt"]}><div className={styles["locked-resource-prompt__content"]}><LockIconZoomedIn className={styles["locked-resource-prompt__lock-icon"]} /><h3 className={styles["locked-resource-prompt__heading"]}>{cmsContent.lockedResourceModalHeading}</h3><p className={styles["locked-resource-prompt__subheading"]}>{subheading}</p></div><div className={styles["locked-resource-prompt__actions"]}>{primaryButton}{cancelButton}</div><div className={styles["locked-resource-prompt__actions--secondary"]}>{cancelButton}{primaryButton}</div></div></Dialog>}</ModalTrigger>;
    $[14] = cancelButton;
    $[15] = cmsContent.lockedResourceModalHeading;
    $[16] = isLockedResourcePromptVisible;
    $[17] = primaryButton;
    $[18] = subheading;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  let t7;
  if ($[20] !== onResourceClick || $[21] !== shouldLockedResourcePromptBeShown || $[22] !== t6) {
    t7 = {
      onResourceClick,
      renderLockedResourcePrompt: t6,
      shouldLockedResourcePromptBeShown
    };
    $[20] = onResourceClick;
    $[21] = shouldLockedResourcePromptBeShown;
    $[22] = t6;
    $[23] = t7;
  } else {
    t7 = $[23];
  }
  return t7;
};